import {$, w} from './constants';

// Botón que te lleva a la parte superior de la página

// Click en el botón para que te lleve a la parte superior
$('.btnUp').click(function(){
    $('body, html').animate({
        scrollTop: '0px'
    }, 300);
});
	
// Condición donde aparece botón después de un scroll de 400px
$(window).scroll(function(){
		var y = $(this).scrollTop();
		if (y > 400) {
			$('.btnUp').fadeIn();
		} else {
			$('.btnUp').fadeOut();
		}
});







// WEBPACK FOOTER //
// ./es6/buttons.js